import { render, staticRenderFns } from "./CastingReportDataTable.vue?vue&type=template&id=2602578b&scoped=true"
import script from "./CastingReportDataTable.vue?vue&type=script&lang=js"
export * from "./CastingReportDataTable.vue?vue&type=script&lang=js"
import style0 from "./CastingReportDataTable.vue?vue&type=style&index=0&id=2602578b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2602578b",
  null
  
)

export default component.exports